import { render } from "./checkRatesComponent.vue?vue&type=template&id=a726bdb6&scoped=true"
import script from "./checkRatesComponent.vue?vue&type=script&lang=js"
export * from "./checkRatesComponent.vue?vue&type=script&lang=js"

import "./checkRatesComponent.vue?vue&type=style&index=0&id=a726bdb6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a726bdb6"]])

export default __exports__